<script setup>
import {computed, inject, onMounted, reactive, ref, watch} from 'vue'
import JobListItemBE from './JobListItemBE.vue'

const emitter = inject('emitter')

const props = defineProps([
    'parentSection',
    'jobLink',
    'jobTranslations',
    'defaultContactImage',
    'language',
    'specificJobId',
    'jobType'
])

const state = reactive({
    items: [],
    current_page: 1,
    per_page: 10,
    last_page: 1,
})

const currentParams = reactive({
    name: null,
    salary: null,
    place: null,
})

const urlParams = new URLSearchParams(window.location.search);
const salary = urlParams.get('salary');

if (salary && !isNaN(salary)) {
    currentParams.salary = salary;
}

listJobOffers({
    page: state.current_page,
    per_page: state.per_page,
    salary: currentParams.salary
})

function listJobOffers(search_params) {
    if (props.specificJobId) {
        axios.get('/api/job-offers/get', {
            params: {
                language: props.language ?? '',
                specificJobId: props.specificJobId,
                jobType: props.jobType ?? 'all'
            }
        }).then( response => {
            // console.log('hmm', response.data)
            state.items = response.data
        }).catch( error =>  {
            console.log(error)
        })
    } else {
        axios.get('/api/job-offers/get', {
            params: {
                page: search_params.page ?? state.current_page,
                per_page: search_params.per_page ?? state.per_page,
                name: search_params.name ?? '',
                salary: search_params.salary ?? null,
                place: search_params.place ?? '',
                language: props.language ?? '',
                jobType: props.jobType ?? 'all'
            }
        }).then( response => {
            // console.log('response', response.data)
            state.items = response.data.data
            state.current_page = response.data.current_page
            state.per_page = response.data.per_page
            state.last_page = response.data.last_page
            setTimeout( () => {
                let items = document.querySelectorAll('.job-finder__list-item')
                let tagElements = []

                // console.log(items)

               items.forEach( item => {
                   let imgElement = item.querySelector('.c-tag img[src="/img/icons/money.svg"]')
                   let cTagElement = imgElement.closest('.c-tag')

                     if (cTagElement) {
                          tagElements.push(cTagElement)
                     }
                })

                let widthestElement = tagElements.reduce((a, b) => {
                    // console.log(a.offsetWidth, b.offsetWidth)
                    return a.offsetWidth > b.offsetWidth ? a : b
                })

                // console.log(widthestElement.offsetWidth)

                tagElements.forEach(element => {
                    element.style.width = widthestElement.offsetWidth + 'px'
                })
            }, 500)
        }).catch( error =>  {
            console.log(error)
        })
    }
}

function switchPage(search_params) {
    listJobOffers(search_params)
    let parent_section = document.getElementById(props.parentSection)
    if (parent_section) {
        parent_section.scrollIntoView({
            behavior: 'smooth'
        })
    }
}

/*function generatePaginationArray(currentPage, totalPages) {
    let paginationArray = [];

    // display all available pages
    if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
            paginationArray.push(i);
        }
    } else {
        /*if (currentPage <= 2) {
            paginationArray.push(1, 2, 3, '...', totalPages - 1, totalPages);
        } else if (currentPage >= totalPages - 1) {
            paginationArray.push(1, 2, '...', totalPages - 2, totalPages - 1, totalPages);
        } else {
            paginationArray.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
        }*/
        /*if (currentPage <= 2) {
            paginationArray = [];
            paginationArray.push(1, 2, 3, '...', totalPages - 1, totalPages);
        } else if (currentPage >= totalPages - 2) {
            paginationArray = [];
            paginationArray.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
        } else {
            paginationArray = [];
            paginationArray.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
        }
    }

    return paginationArray;
}*/

onMounted(() => {
    // console.log('mounted')
    emitter.on('setSearchParams', (params) => {
        console.log("emit setSearchParams")
        currentParams.name = params.name
        currentParams.salary = params.salary
        currentParams.place = params.place
    })
    emitter.on('searchJobOffers', (params) => {
        console.log("emit searchJobOffers")
        listJobOffers({
            page: params.page ?? state.current_page,
            per_page: params.per_page ?? state.per_page,
            name: params.name ?? currentParams.name,
            salary: params.salary ?? currentParams.salary,
            place: params.place ?? currentParams.place,
        })
    })
})

    const generatePaginationArray = () => {

        const currentPage = state.current_page
        const totalPages = state.last_page

        let paginationArray = [];

        // display all available pages
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                paginationArray.push(i);
            }
        } else {
            if (currentPage <= 2) {
                paginationArray = [];
                paginationArray.push(1, 2, 3, null, totalPages - 1, totalPages);
            } else if (currentPage >= totalPages - 2) {
                paginationArray = [];
                paginationArray.push(1, null, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                paginationArray = [];
                paginationArray.push(1, null, currentPage - 1, currentPage, currentPage + 1, null, totalPages);
            }
        }

        return paginationArray;
    };

    const paginationArray = ref(generatePaginationArray());

    watch(() => [state.current_page, state.last_page], () => {
        paginationArray.value = generatePaginationArray();
    });

    const computedPaginationArray = computed(() => paginationArray.value);
</script>

<template v-if="state.items && state.items.length">
    <ul class="job-finder__list">
        <template v-for="item in state.items">
            <JobListItemBE :data="item" :job-link="jobLink" :job-translations="jobTranslations" :default-contact-image="defaultContactImage" :specificJobId="specificJobId" />
        </template>
        <div v-if="!specificJobId && (!state.items || !state.items.length)" class="col-12 d-flex justify-content-center align-items-center">
            <p class="m-3">{{ jobTranslations['Ponuka - žiadne výsledky']}}</p>
        </div>
    </ul>
    <div v-if="state.items && state.items.length && !specificJobId" class="archive-navigation">
        <div class="left">
            <!--<label for="per_page">
                Počet ponúk na stranu
            </label>
            <select name="per_page" id="per_page">
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
            </select>-->
        </div>
        <div class="right">
            <nav class="c-pagination">
                <ul>
                    <li v-for="page in computedPaginationArray" :key="page">
                        <a v-if="page" @click="switchPage({page: page, per_page: state.per_page, name: currentParams.name, salary: currentParams.salary, place: currentParams.place})" :class="{active: (state.current_page === page)}">
                            {{ page }}
                        </a>
                        <span v-else>...</span>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>
